const SvgFacebook = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M18.199 30.667V15.999h3.944l.523-5.055h-4.467l.007-2.53c0-1.318.122-2.025 1.967-2.025h2.466V1.334h-3.945c-4.739 0-6.407 2.452-6.407 6.576v3.035H9.333V16h2.954v14.668h5.912z" />
  </svg>;
export default SvgFacebook;